import { HealthGoals, MASONRY_V2 } from '@highmark-web/highmark-common';
import {
  ActivityStackWidgetV2,
  HEALTH_JOURNEY_NAMESPACE,
  HEALTH_JOURNEY_NODE_TYPES,
  RewardsProgramCardCarouselWidgetV2,
} from '@leagueplatform/health-journey';
import {
  MasonryDriverNodeRenderersRegistry,
  MasonryWSDriverNodeRenderersRegistry,
} from '@leagueplatform/masonry';

export const initAppMasonryRegistry = () => {
  MasonryWSDriverNodeRenderersRegistry.overrideRenderer(
    HEALTH_JOURNEY_NAMESPACE,
    HEALTH_JOURNEY_NODE_TYPES.ACTIVITIES_WIDGET,
    ActivityStackWidgetV2,
  );

  MasonryDriverNodeRenderersRegistry.registerRenderer(
    MASONRY_V2.NAMESPACE_DEFAULT,
    MASONRY_V2.CUSTOM_WIDGET_TYPE_REWARD_PROGRAM_CAROUSEL,
    RewardsProgramCardCarouselWidgetV2,
  );

  MasonryDriverNodeRenderersRegistry.registerRenderer(
    MASONRY_V2.NAMESPACE_DEFAULT,
    MASONRY_V2.CUSTOM_WIDGET_TYPE_HEALTH_GOALS,
    HealthGoals,
  );
};
